package com.patronat.top.client.presentation.auth

import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.WindowInsets
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.safeDrawing
import androidx.compose.foundation.layout.windowInsetsPadding
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import com.patronat.top.ui.theme.White

@Composable
fun ClientAuthScreen(
    state: ClientAuthViewState,
    onEvent: (ClientAuthEvent) -> Unit,
    modifier: Modifier = Modifier
) {
    Box(
        modifier = modifier
            .fillMaxSize()
            .background(White)
            .windowInsetsPadding(WindowInsets.safeDrawing),
        contentAlignment = Alignment.TopCenter
    ) {
        when (state.step) {
            ClientAuthStep.GetStarted -> ClientGetStartedContent(
                onRegisterByPhoneClick = { onEvent(ClientAuthEvent.OnRegisterByPhoneClicked) },
                onLoginByPhoneClick = { onEvent(ClientAuthEvent.OnLoginByPhoneClicked) },
                onContinueWithoutAccountClick = { onEvent(ClientAuthEvent.OnContinueWithoutAccountClicked) }
            )

            ClientAuthStep.RegistrationForm -> ClientRegistrationContent(
                state = state,
                onEvent = onEvent
            )

            ClientAuthStep.LoginForm -> ClientLoginContent(
                state = state,
                onEvent = onEvent
            )

            ClientAuthStep.VerifyPhone -> ClientVerifyPhoneContent(
                state = state,
                onEvent = onEvent
            )
        }

        if (state.showSuccessSheet) {
            ClientRegistrationSuccessSheet(
                onDismissRequest = { onEvent(ClientAuthEvent.OnDismissSuccess) },
                onPrimaryClick = { onEvent(ClientAuthEvent.OnSuccessPrimaryClicked) }
            )
        }
    }
}
